import { DiscountCodeCard } from '@gamiphy/loyalty-station-desktop/components/redeem/discountCode';
import { DiscountStore } from '@gamiphy/loyalty-station-desktop/store/reward/discount';
import { Tabs, UiStore } from '@gamiphy/loyalty-station-desktop/store/ui';
import { Trans } from '@gamiphy/react-i18n';
import {
  Box, Button, Card, CardContent, CardHeader, Grid,
} from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';

const RedeemHistoryPage: React.FC = observer(() => {
  const title = React.useMemo(
    () => (
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid>
          <Trans i18nKey="redeemHistory.title" defaults="Redeem History" />
        </Grid>
        <Grid>
          <Button
            color="primary"
            variant="text"
            onClick={() => {
              UiStore.closePage();
              UiStore.setTab(Tabs.Redeem);
            }}
          >
            <Trans i18nKey="shared.redeem" defaults="Redeem" />
          </Button>
        </Grid>
      </Grid>
    ),
    [],
  );

  return (
    <Box sx={(theme) => ({ width: '100%', p: theme.spacing(2) })}>
      <Card>
        <CardHeader title={title} />
        <CardContent>
          <Grid container spacing={2}>
            {DiscountStore.discounts?.map((discountCode) => (
              <Grid key={discountCode.id} size={12}>
                <DiscountCodeCard
                  discount={discountCode}
                />
              </Grid>
            ))}
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
});

export default RedeemHistoryPage;
